import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 是否使用
 */
class HasUsed extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}

export const HAS_USED = new HasUsed();

class GoodsDef extends UltMeta {
    /**
     * 货物名称
     */
    WEIGHT = new Meta(1, "重量");
    /**
     * 单位分类
     */
    VOLUME = new Meta(2, "体积");
    /**
     * 单位
     */
    CUSTOMIZE = new Meta(3, "自定义");
}

export const GOODS_DEF = new GoodsDef();

export class WeightUnit extends UltMeta {
    // 克、千克、吨
    G = new Meta("克", "克");
    KG = new Meta("千克", "千克");
    T = new Meta("吨", "吨");
}
export const WEIGHT_UNIT = new WeightUnit();

export class VolumetUnit extends UltMeta {
    //毫升、升、立方米
    ML = new Meta("毫升", "毫升");
    L = new Meta("升", "升");
    M3 = new Meta("立方米", "立方米");
}
export const VOLUME_UNIT = new VolumetUnit();
